var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConfirmIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57188_73995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1852 4.62133C17.2138 4.83338 17.2292 5.05032 17.2292 5.27059C17.2292 7.91143 15.1101 10.052 12.4982 10.052C9.88507 10.052 7.76709 7.91143 7.76709 5.27059C7.76709 2.63008 9.88507 0.489502 12.4982 0.489502C13.7337 0.489502 14.8593 0.968633 15.7021 1.75332",
    stroke: "#FFC700",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2837 4.92141L12.5524 7.21365L16.6838 3.03735",
    stroke: "#FFC700",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.68652 16.5911H16.1487",
    stroke: "#4076B4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.68652 18.5952H14.2001",
    stroke: "#4076B4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.68652 20.5991H9.46906",
    stroke: "#4076B4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4932 22.5959L25.2741 14.7319C25.4942 14.5093 25.4942 14.1488 25.2741 13.9261L23.4114 12.0437C23.1914 11.8211 22.8349 11.8211 22.6148 12.0437L14.8702 19.8707C14.3652 20.3804 14.0483 21.0495 13.9713 21.7665L13.7578 23.7656L15.7097 23.4924C16.3852 23.3981 17.0112 23.0833 17.4932 22.5959Z",
    stroke: "#4076B4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9355 19.8042L17.5959 22.4924",
    stroke: "#4076B4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6416 13.0269L24.7212 16.1384C24.9897 16.4095 24.9897 16.8487 24.7212 17.1199L21.9739 19.8954",
    stroke: "#4076B4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9014 12.4796L24.5538 11.8214C24.6616 11.7122 24.8366 11.7122 24.9455 11.8214L25.4637 12.3459C25.5716 12.4552 25.5716 12.6322 25.4637 12.7414L24.8124 13.3996",
    stroke: "#4076B4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.68652 12.5833H18.0961",
    stroke: "#4076B4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.68652 14.5872H18.0961",
    stroke: "#4076B4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1821 3.02075H19.8061C20.7677 3.02075 21.5478 3.80867 21.5478 4.78083V10.8746",
    stroke: "#4076B4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5478 21.3747V23.7603C21.5478 24.7325 20.7678 25.5208 19.8051 25.5208H5.19044C4.22772 25.5208 3.44873 24.7325 3.44873 23.7603V4.78083C3.44873 3.80867 4.22772 3.02075 5.19044 3.02075H6.68677",
    stroke: "#4076B4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.36328 23.6868C8.47673 22.8487 8.75509 23.9739 9.59019 23.7117C10.3868 23.4613 10.7025 22.005 11.2593 23.1244C11.7775 24.1656 12.6511 23.7117 12.6511 23.7117",
    stroke: "#4076B4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57188_73995"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 26,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmIcon);
export default __webpack_public_path__ + "static/media/confirm_icon.b5decb94f657114f4ff9e2365d893e48.svg";
export { ForwardRef as ReactComponent };